import { useSelector } from 'react-redux'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { Item } from '@calendly/ui/components/menu'

import { useI18n } from 'locales'
import { currentUserLocaleSelector } from 'selectors/user'
import { Menu } from 'components/publisher_toolbar/dropdown/styles'
import { MenuButton } from 'components/publisher_toolbar/dropdown/menu_button'
import { canRequestDiagnosticsSelector } from 'selectors/diagnostics'
import { useMeetingTypesPath } from 'hooks/use_meeting_types_path'
import { useRoutingForm } from 'components/use_routing_form'

import { Container } from './styles'

export const RoutingFormPublisherToolbar = () => {
  const { i18n } = useI18n()
  const locale = useSelector(currentUserLocaleSelector)
  const [toggleDropdown, Wrapper, isExpanded] = useDropdown()
  const routingForm = useRoutingForm()
  const meetingTypesRoute = useMeetingTypesPath()
  const canRequestDiagnostics = useSelector(canRequestDiagnosticsSelector)

  if (!routingForm || !canRequestDiagnostics) return null

  const { id } = routingForm

  return (
    <Container>
      <MenuButton
        toggleDropdown={toggleDropdown}
        isExpanded={isExpanded}
      />
      <Wrapper>
        <Menu>
          <Item as="a" href={meetingTypesRoute}>{i18n.t('publisher.menu.home', { locale })}</Item>
          <Item as="a" href={`/app/routing/forms/${id}/edit/fields`}>
            {i18n.t('publisher.diagnostics.publisher_toolbar.edit_landing_page', { locale })}
          </Item>
        </Menu>
      </Wrapper>
    </Container>
  )
}
